import { MedifitError } from '@meddev/fe-shared';

export class MedifitErrorDefinition {
    private static employeeErrors: { [key: string]: MedifitError } = {
        PREVENTIVNI_EMPLOYEE_NOT_FOUND: {
            code: 'PREVENTIVNI_EMPLOYEE_NOT_FOUND',
            displayMessage: 'Delavca ni mogoče najti.',
        },
        PREVENTIVNI_EMPLOYEE_DELETED: {
            code: 'PREVENTIVNI_EMPLOYEE_DELETED',
            displayMessage: 'Delavec je izbrisan.',
        },
        PREVENTIVNI_EMPLOYEE_WITH_EMSO_EXISTS: {
            code: 'PREVENTIVNI_EMPLOYEE_WITH_EMSO_EXISTS',
            displayMessage: 'Delavec s to EMŠO številko je že vnesen v sistem.',
        },
    };

    private static employerErrors: { [key: string]: MedifitError } = {
        PREVENTIVNI_EMPLOYER_NOT_FOUND: {
            code: 'PREVENTIVNI_EMPLOYER_NOT_FOUND',
            displayMessage: 'Podjetja ni mogoče najti.',
        },
        PREVENTIVNI_EMPLOYER_DELETED: {
            code: 'PREVENTIVNI_EMPLOYER_DELETED',
            displayMessage: 'Podjetje je izbrisano.',
        },
        PREVENTIVNI_INVALID_REGISTRATION_NUMBER: {
            code: 'PREVENTIVNI_INVALID_REGISTRATION_NUMBER',
            displayMessage: 'Matična številka mora biti dolga 10 znakov.',
        },
        PREVENTIVNI_INVALID_TAX_NUMBER: {
            code: 'PREVENTIVNI_INVALID_TAX_NUMBER',
            displayMessage: 'Davčna številka mora biti dolga 8 ali 10 znakov.',
        },
        PREVENTIVNI_EMPLOYER_HAS_CHILD_EMPLOYERS: {
            code: 'PREVENTIVNI_EMPLOYER_HAS_CHILD_EMPLOYERS',
            displayMessage: 'Podjetja s podrejenimi enotami ni mogoče izbrisati.',
        },
    };

    private static workplaceErrors: { [key: string]: MedifitError } = {
        PREVENTIVNI_WORKPLACE_TEMPLATE_NOT_FOUND: {
            code: 'PREVENTIVNI_WORKPLACE_TEMPLATE_NOT_FOUND',
            displayMessage: 'Predloge delovnega mesta ni mogoče najti.',
        },
        PREVENTIVNI_WORKPLACE_TEMPLATE_ALREADY_EXISTS: {
            code: 'PREVENTIVNI_WORKPLACE_TEMPLATE_ALREADY_EXISTS',
            displayMessage: 'Predloga delovnega mesta s tem imenom že obstaja.',
        },
        PREVENTIVNI_WORKPLACE_TEMPLATE_ALREADY_DELETED: {
            code: 'PREVENTIVNI_WORKPLACE_TEMPLATE_ALREADY_DELETED',
            displayMessage: 'Predloga delovnega mesta je že izbrisana.',
        },
        PREVENTIVNI_WORKPLACE_NOT_FOUND: {
            code: 'PREVENTIVNI_WORKPLACE_NOT_FOUND',
            displayMessage: 'Delovnega mesta ni mogoče najti.',
        },
        PREVENTIVNI_WORKPLACE_ALREADY_EXISTS: {
            code: 'PREVENTIVNI_WORKPLACE_ALREADY_EXISTS',
            displayMessage: 'Delovno mesto s tem imenom že obstaja.',
        },
        PREVENTIVNI_WORKPLACE_DELETED: {
            code: 'PREVENTIVNI_WORKPLACE_DELETED',
            displayMessage: 'Delovno mesto je izbrisano.',
        },
    };

    private static referralErrors: { [key: string]: MedifitError } = {
        PREVENTIVNI_REFERRAL_NOT_FOUND: {
            code: 'PREVENTIVNI_REFERRAL_NOT_FOUND',
            displayMessage: 'Napotnice ni mogoče najti.',
        },
        PREVENTIVNI_INVALID_LEGAL_BASIS_DATA: {
            code: 'PREVENTIVNI_INVALID_LEGAL_BASIS_DATA',
            displayMessage: 'Podatki o pravni podlagi niso veljavni.',
        },
        PREVENTIVNI_REFERRAL_DELETED: {
            code: 'PREVENTIVNI_REFERRAL_DELETED',
            displayMessage: 'Napotnica je izbrisana.',
        },
        PREVENTIVNI_REFERRAL_SIGNING_FAILED: {
            code: 'PREVENTIVNI_REFERRAL_SIGNING_FAILED',
            displayMessage: 'Podpisovanje napotnice ni uspelo.',
        },
        PREVENTIVNI_REFERRAL_UPLOAD_FAILED: {
            code: 'PREVENTIVNI_REFERRAL_UPLOAD_FAILED',
            displayMessage: 'Nalaganje napotnice ni uspelo.',
        },
    };

    private static reservationErrors: { [key: string]: MedifitError } = {
        PREVENTIVNI_RESERVATION_NOT_FOUND: {
            code: 'PREVENTIVNI_RESERVATION_NOT_FOUND',
            displayMessage: 'Rezervacije ni mogoče najti.',
        },
        PREVENTIVNI_INVALID_BOOKING_DUE_DATE: {
            code: 'PREVENTIVNI_INVALID_BOOKING_DUE_DATE',
            displayMessage: 'Rok za naročilo ni veljaven.',
        },
        PREVENTIVNI_RESERVATION_CANCELED: {
            code: 'PREVENTIVNI_RESERVATION_CANCELED',
            displayMessage: 'Rezervacija je preklicana.',
        },
        PREVENTIVNI_RESERVATION_CONCLUDED: {
            code: 'PREVENTIVNI_RESERVATION_CONCLUDED',
            displayMessage: 'Rezervacija je že zaključena.',
        },
        PREVENTIVNI_REFERRAL_HAS_RESERVATION: {
            code: 'PREVENTIVNI_REFERRAL_HAS_RESERVATION',
            displayMessage: 'Za to napotnico rezervacija že obstaja.',
        },
    };

    private static bookingErrors: { [key: string]: MedifitError } = {
        PREVENTIVNI_BOOKING_NOT_FOUND: {
            code: 'PREVENTIVNI_BOOKING_NOT_FOUND',
            displayMessage: 'Naročila ni mogoče najti.',
        },
        PREVENTIVNI_BOOKING_FROM_TO_MISSING: {
            code: 'PREVENTIVNI_BOOKING_FROM_TO_MISSING',
            displayMessage: 'Manjkata začetni in končni čas naročila.',
        },
        PREVENTIVNI_BOOKING_ALREADY_EXISTS: {
            code: 'PREVENTIVNI_BOOKING_ALREADY_EXISTS',
            displayMessage: 'Aktivno naročilo za to rezervacijo že obstaja.',
        },
    };

    private static internalErrors: { [key: string]: MedifitError } = {
        PREVENTIVNI_IMPORT_HISTORY_NOT_FOUND: {
            code: 'PREVENTIVNI_IMPORT_HISTORY_NOT_FOUND',
            displayMessage: 'Zgodovine uvoza ni mogoče najti.',
        },
        PREVENTIVNI_MBSIP_CASE_CREATION_FAILED: {
            code: 'PREVENTIVNI_MBSIP_CASE_CREATION_FAILED',
            displayMessage: 'Naročila ni bilo mogoče ustvariti. Poskusite znova.',
        },
        PREVENTIVNI_MBSIP_CASE_NOT_FOUND: {
            code: 'PREVENTIVNI_MBSIP_CASE_NOT_FOUND',
            displayMessage: 'Pripadajočega primera ni mogoče najti.',
        },
        PREVENTIVNI_BS_ID_REQUIRED: {
            code: 'PREVENTIVNI_BS_ID_REQUIRED',
            displayMessage: 'Manjka identifikator podjetja. Poskusite znova.',
        },
        PREVENTIVNI_MISSING_REQUIRED_FIELD: {
            code: 'PREVENTIVNI_MISSING_REQUIRED_FIELD',
            displayMessage: 'Manjka obvezno polje.',
        },
        PREVENTIVNI_USER_NOT_FOUND: {
            code: 'PREVENTIVNI_USER_NOT_FOUND',
            displayMessage: 'Uporabnika ni mogoče najti. Prijavite se znova.',
        },
    };

    public static errors: { [key: string]: MedifitError } = {
        ...MedifitErrorDefinition.employeeErrors,
        ...MedifitErrorDefinition.employerErrors,
        ...MedifitErrorDefinition.workplaceErrors,
        ...MedifitErrorDefinition.referralErrors,
        ...MedifitErrorDefinition.reservationErrors,
        ...MedifitErrorDefinition.bookingErrors,
        ...MedifitErrorDefinition.internalErrors,
    };
}
